module.exports = __webpack_public_path__ + "static/media/panel_info_off.46af8a30.svg";